module.exports = require("nestjs-pino");